export enum TableHeaderColumn {
  ELLIPSIS = 'header-ellipsis',
  ACTIONS = 'header-actions'
}
